import React, { useState } from 'react';
import { MailIcon, PhoneIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Select } from '../components/ui/Select';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../lib/i18n';
const WEB3FORMS_ACCESS_KEY = 'b7789131-e060-4196-aa41-6a4c61a3a4d1';
const WEB3FORMS_ACTION = 'https://api.web3forms.com/submit';
export function ContactPage() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitError(null);
    const formData = new FormData(e.currentTarget);
    const payload: Record<string, string> = {
      access_key: WEB3FORMS_ACCESS_KEY,
      subject: 'Kontakt upit - D-TECH Solutions',
      from_name: 'D-TECH sajt - kontakt',
      botcheck: ''
    };
    formData.forEach((value, key) => {
      if (typeof value === 'string') payload[key] = value;
    });
    setIsSubmitting(true);
    try {
      const response = await fetch(WEB3FORMS_ACTION, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setIsSubmitting(false);
        setSubmitSuccess(true);
      } else {
        setIsSubmitting(false);
        setSubmitError(en ? 'Sending failed. Please try again or contact us directly.' : ru ? 'Отправка не удалась. Пожалуйста, попробуйте еще раз или свяжитесь с нами напрямую.' : 'Slanje nije uspelo. Pokušajte ponovo ili nas kontaktirajte direktno.');
      }
    } catch (err) {
      setIsSubmitting(false);
      setSubmitError(en ? 'Network error. Please try again or contact us directly.' : ru ? 'Ошибка сети. Пожалуйста, попробуйте еще раз или свяжитесь с нами напрямую.' : 'Greška u mreži. Pokušajte ponovo ili nas kontaktirajte direktno.');
    }
  };
  return <main className="min-h-screen bg-dark-bg" data-id="element-666">
      <section className="py-20 bg-dark-surface border-b-2 border-dark-border" data-id="element-667">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-668">
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6" data-id="element-669">
            <span className="text-brand-yellow" data-id="element-670">
              {en ? 'Contact' : ru ? 'Свяжитесь с' : 'Kontaktirajte'}
            </span>{' '}
            {en ? 'us' : ru ? 'нами' : 'nas'}
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-671">
            {en ? 'Get in touch with our team for product inquiries, technical support or partnership opportunities.' : ru ? 'Свяжитесь с нашей командой для запросов о продукции, технической поддержки или возможностей партнерства.' : 'Stupite u kontakt sa našim timom za upite o proizvodima, tehničku podršku ili mogućnosti partnerstva.'}
          </p>
        </div>
      </section>

      <section className="py-20" data-id="element-672">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-673">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-674">
            <div data-id="element-675">
              <h2 className="text-3xl font-black text-white mb-6" data-id="element-676">
                {en ? 'Send us a message' : ru ? 'Отправьте нам сообщение' : 'Pošaljite nam poruku'}
              </h2>
              {submitSuccess ? <Card data-id="element-677">
                  <div className="text-center py-8" data-id="element-678">
                    <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-679">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-680">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-681" />
                      </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2" data-id="element-682">
                      {en ? 'Message sent!' : ru ? 'Сообщение отправлено!' : 'Poruka poslata!'}
                    </h3>
                    <p className="text-gray-300" data-id="element-683">
                      {en ? 'Thank you for contacting us. We will get back to you shortly.' : ru ? 'Спасибо, что связались с нами. Мы ответим вам в ближайшее время.' : 'Hvala vam što ste nas kontaktirali. Uskoro ćemo vam se javiti.'}
                    </p>
                  </div>
                </Card> : <Card data-id="element-684">
                  <form onSubmit={handleSubmit} className="space-y-6" noValidate data-id="element-685">
                    <Input label={en ? 'Full name *' : ru ? 'Полное имя *' : 'Ime i prezime *'} type="text" name="Ime_i_prezime" required placeholder={en ? 'Your name' : ru ? 'Ваше имя' : 'Vaše ime i prezime'} data-id="element-686" />
                    <Input label={en ? 'Email *' : 'Email *'} type="email" name="email" required placeholder={en ? 'your@email.com' : ru ? 'vas.email@primer.com' : 'vas.email@primer.com'} data-id="element-687" />
                    <Input label={en ? 'Phone *' : ru ? 'Телефон *' : 'Telefon *'} type="tel" name="Telefon" required placeholder={en ? '+1 ...' : ru ? '+7 ...' : '+381 60 123 4567'} data-id="element-688" />
                    <Select label={en ? 'Inquiry type *' : ru ? 'Тип запроса *' : 'Tip upita *'} name="Tip_upita" required defaultValue="" options={[{
                  value: '',
                  label: en ? 'Select category...' : ru ? 'Выберите категорию...' : 'Izaberite kategoriju...',
                  disabled: true
                }, {
                  value: 'Stepenisne penjace',
                  label: en ? 'Stair climbers' : ru ? 'Лестничные подъемники' : 'Stepenišne penjače'
                }, {
                  value: 'Elektricna kolica',
                  label: en ? 'Electric carts' : ru ? 'Электрические тележки' : 'Električna kolica'
                }, {
                  value: 'Opsti upit',
                  label: en ? 'General inquiry' : ru ? 'Общий запрос' : 'Opšti upit'
                }]} data-id="element-689" />
                    <Textarea label={en ? 'Message *' : ru ? 'Сообщение *' : 'Poruka *'} name="Poruka" required placeholder={en ? 'Tell us about your needs or questions' : ru ? 'Расскажите нам о ваших потребностях или вопросах' : 'Recite nam o vašim potrebama ili pitanjima'} rows={6} data-id="element-690" />
                    {submitError && <div className="p-4 bg-red-500/10 border-2 border-red-500/50 rounded-industrial text-sm text-red-300" data-id="element-691">
                        {submitError}
                      </div>}
                    <Button type="submit" variant="primary" size="lg" disabled={isSubmitting} className="w-full" data-id="element-692">
                      {isSubmitting ? en ? 'Sending...' : ru ? 'Отправка...' : 'Šaljem...' : en ? 'Send message' : ru ? 'Отправить сообщение' : 'Pošalji poruku'}
                    </Button>
                    <p className="text-sm text-brand-yellow text-center font-semibold" data-id="element-693">
                      {en ? 'We respond to all inquiries within 24h.' : ru ? 'Мы отвечаем на все запросы в течение 24 часов.' : 'Odgovaramo na upit u roku od 24h.'}
                    </p>
                  </form>
                </Card>}
            </div>

            <div data-id="element-694">
              <h2 className="text-3xl font-black text-white mb-6" data-id="element-695">
                {en ? 'Contact information' : ru ? 'Контактная информация' : 'Kontakt informacije'}
              </h2>
              <div className="space-y-6" data-id="element-696">
                <Card data-id="element-697">
                  <div className="flex items-start space-x-4" data-id="element-698">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-699">
                      <MailIcon className="w-6 h-6 text-dark-bg" data-id="element-700" />
                    </div>
                    <div data-id="element-701">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-702">
                        {ru ? 'Эл. почта' : 'Email'}
                      </h3>
                      <a href="mailto:info@dtech.rs" className="text-brand-yellow hover:text-brand-yellow-dark transition-colors text-lg" data-id="element-703">
                        info@dtech.rs
                      </a>
                      <p className="text-sm text-gray-400 mt-2" data-id="element-704">
                        {en ? 'For all inquiries, quotes and support' : ru ? 'Для всех запросов, предложений и поддержки' : 'Za sve upite, ponude i podršku'}
                      </p>
                    </div>
                  </div>
                </Card>
                <Card data-id="element-705">
                  <div className="flex items-start space-x-4" data-id="element-706">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-707">
                      <PhoneIcon className="w-6 h-6 text-dark-bg" data-id="element-708" />
                    </div>
                    <div data-id="element-709">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-710">
                        {en ? 'Phone' : ru ? 'Телефон' : 'Telefon'}
                      </h3>
                      <a href="tel:+381653312811" className="text-brand-yellow hover:text-brand-yellow-dark transition-colors text-lg" data-id="element-711">
                        065 331 2811
                      </a>
                      <p className="text-sm text-gray-400 mt-2" data-id="element-712">
                        {en ? 'Call us during working hours' : ru ? 'Звоните нам в рабочее время' : 'Pozovite nas u toku radnog vremena'}
                      </p>
                    </div>
                  </div>
                </Card>
                <Card data-id="element-713">
                  <div className="flex items-start space-x-4" data-id="element-714">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-715">
                      <ClockIcon className="w-6 h-6 text-dark-bg" data-id="element-716" />
                    </div>
                    <div data-id="element-717">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-718">
                        {en ? 'Working hours' : ru ? 'Часы работы' : 'Radno vreme'}
                      </h3>
                      <p className="text-gray-300 text-lg" data-id="element-719">
                        {en ? <>
                            Monday - Friday
                            <br data-id="element-720" />
                            10:00 - 17:00 (CET)
                          </> : ru ? <>
                            Понедельник - Пятница
                            <br data-id="element-721" />
                            10:00 - 17:00 (CET)
                          </> : <>
                            Ponedeljak - Petak
                            <br data-id="element-722" />
                            10:00 - 17:00 (CET)
                          </>}
                      </p>
                      <p className="text-sm text-gray-400 mt-2" data-id="element-723">
                        {en ? 'We respond to all inquiries within 24 business hours' : ru ? 'Мы отвечаем на все запросы в течение 24 рабочих часов' : 'Odgovaramo na sve upite u roku od 24 radna sata'}
                      </p>
                    </div>
                  </div>
                </Card>
                <Card data-id="element-724">
                  <div className="flex items-start space-x-4" data-id="element-725">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-726">
                      <MapPinIcon className="w-6 h-6 text-dark-bg" data-id="element-727" />
                    </div>
                    <div data-id="element-728">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-729">
                        {en ? 'Location' : ru ? 'Местоположение' : 'Lokacija'}
                      </h3>
                      <p className="text-gray-300" data-id="element-730">
                        {en ? <>
                            Online-first business
                            <br data-id="element-731" />
                            Physical location in preparation
                          </> : ru ? <>
                            Бизнес в первую очередь онлайн
                            <br data-id="element-732" />
                            Физическое местоположение в стадии подготовки
                          </> : <>
                            Online-first poslovanje
                            <br data-id="element-733" />
                            Fizička lokacija u pripremi
                          </>}
                      </p>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}